import React, { useState } from "react"
import ModularContentProcessor from "../StructuredContent/ModularContentProcessor.js";
import Image from "../AssetManagement/Image.js"
import { IsEmpty, IsTitleTextImage, IsQuizLayout, IsVideoPlaylistLayout, IsCarouselLayout, IsEmptyArray } from "../../helpers/HelperFunctions"
import RenderMedia from "../AssetManagement/RenderMedia.js";
import CopyrightImage from "../CopyrightImage/CopyrightImage.js"
import ImageCaption from "../ImageCaption/ImageCaption.js"
import LayoutQuiz from "./LayoutQuiz.js"
import LayoutVideoPlaylist from "./LayoutVideoPlaylist.js"
import LayoutCarousel from "./LayoutCarousel.js"

export default function LayoutAccordion(props) {
    // State to track if all sections are expanded or collapsed
    const [isExpanded, setIsExpanded] = useState(false);

    // Function to toggle all sections expansion
    const toggleExpansion = (e) => {
        e.preventDefault(); // stop page from jumping to top
        e.target.blur(); // remove focus from the link
        setIsExpanded(!isExpanded);
    };

    const accordionContainerClass = (IsEmpty(props.accordionBackgroundLayout.value)) ? "odd" : props.accordionBackgroundLayout.value[0].name.toLowerCase();

    const getSubSectionClass = (index) => {
        if (accordionContainerClass === "evenimageleft") {
            return (index + 1) % 2 === 0 ? "odd1" : "even1"; // ood1 will not require
        } else if (accordionContainerClass === "oddimageright") {
            return (index + 1) % 2 === 0 ? "even2" : "odd2"; // even2 will not require
        } else {
            return (index + 1) % 2 === 0 ? "even" : "odd"; // Default alternating
        }
    };

    return (

        <>
            <div className={"ou-accordion-article-container accordion-article-" + accordionContainerClass}>
                <div className={"ou-accordion-article-main-" + accordionContainerClass}>
                    {!IsEmptyArray(props.media) &&
                        <div className="ou-accordion-article-image-container">
                            <div className="ou-accordion-article-image">
                                <Image
                                    image={props.media.value}
                                />
                            </div>
                            {!IsEmpty(props.media.value) &&
                                <>
                                    <CopyrightImage
                                        CopyrightCaption={props.media.value[0].elements.caption.value}
                                    />
                                    <ImageCaption
                                        ImageCaption={props.media.value[0].elements.image_caption.value}
                                    />
                                </>
                            }
                        </div>
                    }
                    <div className="ou-accordion-article-summary">

                        <h2 className={"ou-accordion-article-title-" + accordionContainerClass}>{props.title.value}</h2>

                        <p className={"ou-accordion-article-description-" + accordionContainerClass}>
                            <span>{props.description.value}</span>

                            {/* Conditionally render the "...keep reading" or "...read less" link */}
                            <a href="#" className="ou-accordion-toggle-expand" onClick={toggleExpansion}> {isExpanded ? '' : ' ...keep reading'}</a>
                        </p>
                    </div>
                </div>

                <div className="ou-accordion-content" style={{ display: isExpanded ? "block" : "none" }}>

                    {!IsEmpty(props.introduction.value) &&
                        <div>
                            <div className="ou-article-description-col-2" dangerouslySetInnerHTML={{ __html: props.introduction.value }} />
                        </div>
                    }

                    {props.body.modular_content.map(({ elements, id, system }, index) => {

                        return (
                            <div className="ou-accordion-article-sub-section-wrapper" key={"divAccordionWrapper-" + id}>

                                {/* We need to process a quiz component separately, so check for the quiz layout */}
                                {IsQuizLayout(system.type) &&
                                    <LayoutQuiz
                                        iFrameLink={elements.quiz_iframe_link}
                                        title={elements.title}
                                        body={elements.body}
                                    />
                                }

                                {/* We need to process a carousel component separately, so check for the carousel layout */}
                                {IsCarouselLayout(system.type) &&
                                    <LayoutCarousel
                                        carouselTitle={elements.carousel_title}
                                        listOfCarouselItems={elements.list_of_carousel_items}
                                        articleIndex={props.articleIndex}
                                    />
                                }

                                {/* We need to process a video playlist component separately, so check for the VP layout */}
                                {IsVideoPlaylistLayout(system.type) &&
                                    <LayoutVideoPlaylist
                                        listOfVideos={elements.list_of_videos}
                                        playlistTitle={elements.video_playlist_title}
                                        playlistBody={elements.video_playlist_body}
                                        duration_summary={elements.video_playlist_duration_summary}
                                        overlayID={id}
                                    />
                                }


                                {(!IsVideoPlaylistLayout(system.type) && !IsCarouselLayout(system.type) && !IsEmpty(elements.title.value) && IsTitleTextImage(system.type)) &&
                                    <h3 className="ou-accordion-article-sub-section-title">{elements.title.value}</h3>
                                }

                                {IsTitleTextImage(system.type) &&

                                    <div className={`ou-accordion-article-sub-section sub-section-${getSubSectionClass(index)}`}>
                                        {/* Needs to be odd/even */}

                                        {(!IsEmptyArray(elements.asset) || !IsEmpty(elements.quote_text.value)) &&
                                            <div className="ou-accordion-article-sub-section-image-container">

                                                {/* Display media assets.. May have a combination of iFrameLink, image or both. */}
                                                <RenderMedia
                                                    mediaArray={elements.asset}
                                                    imageClassName="ou-accordion-article-sub-section-image"
                                                    showCaptions="true"
                                                    key={elements.asset.id}
                                                />

                                                {!IsEmpty(elements.quote_text.value) &&
                                                    <div className="ou-article-blockquote">
                                                        <blockquote>
                                                            <i className="fa fa-quote-left" aria-hidden="true"></i>
                                                            {elements.quote_text.value}
                                                            <i className="fa fa-quote-right" aria-hidden="true"></i>
                                                        </blockquote>
                                                    </div>
                                                }
                                            </div>
                                        }

                                        <div className="ou-accordion-article-sub-section-content" style={getSubSectionClass(index) === "even1" ? { marginLeft: "0px", marginRight: "30px" } : getSubSectionClass(index) === "odd2" ? { marginLeft: "30px", marginRight: "30px" } : {}}>
                                            <ModularContentProcessor
                                                richText={elements.body}
                                                layoutSection="AccordionSubDescription"
                                            />
                                        </div>
                                    </div>
                                }
                                <hr className="ou-article-break" />
                            </div>

                        )
                    })}

                </div>

            </div>

        </>
    )

}